module.exports = __webpack_public_path__ + "static/img/service_content2_img.99a947c.png";